export const aboutData = {
  brandName: '蓝莓视频',
  brandIntro: '蓝莓视频成立于2024年，是一家专注于高清视频在线播放的特色视频平台。平台以"流畅不卡顿、高清免费看"为核心理念，致力于为用户提供极致的观影体验。作为红桃视频、樱花视频同类型平台中的佼佼者，蓝莓视频汇集了海量电视剧、电影、综艺、动漫、纪录片、短剧及创意视频内容，满足不同用户的多样化观影需求。',
  mission: '让每个人都能随时随地享受高品质视频内容，打造中国领先的特色视频平台。',
  vision: '成为华语地区最受欢迎的视频内容聚合平台，以技术创新驱动内容分发，以用户体验为核心竞争力。',
  features: [
    {
      title: '高清画质',
      description: '支持4K超高清画质播放，影院级视听享受，每一帧都清晰细腻。',
      icon: 'ri-4k-line',
    },
    {
      title: '极速加载',
      description: '自研CDN加速技术，视频秒开不缓冲，告别等待焦虑。',
      icon: 'ri-flashlight-line',
    },
    {
      title: '海量资源',
      description: '涵盖电视剧、电影、综艺、动漫等全品类，每日更新热门内容。',
      icon: 'ri-database-2-line',
    },
    {
      title: '多端同步',
      description: '支持电脑、手机、平板多端无缝切换，随时随地继续观看。',
      icon: 'ri-device-line',
    },
  ],
  stats: [
    { value: '5000万+', label: '月活跃用户' },
    { value: '10万+', label: '视频资源' },
    { value: '99.9%', label: '播放成功率' },
    { value: '4.8', label: '用户评分' },
  ],
  milestones: [
    { year: '2024年3月', event: '蓝莓视频正式上线，开启高清视频新时代' },
    { year: '2024年8月', event: '月活跃用户突破500万，入选年度新锐视频平台' },
    { year: '2025年1月', event: '推出4K超高清专区，引领行业画质升级' },
    { year: '2025年6月', event: '月活跃用户突破2000万，完成A轮融资' },
    { year: '2025年12月', event: '上线短剧频道，日播放量突破1亿次' },
    { year: '2026年6月', event: '月活跃用户突破5000万，行业排名进入前五' },
  ],
  testimonials: [
    {
      name: '王先生',
      role: '资深影迷',
      content: '蓝莓视频的画质真是没话说，4K看起来太爽了！而且加载速度超快，比其他平台流畅多了。',
      rating: 5,
    },
    {
      name: '李女士',
      role: '追剧达人',
      content: '以前用其他平台总是卡顿，自从换了蓝莓视频，追剧体验提升了一大截。短剧频道也特别上瘾！',
      rating: 5,
    },
    {
      name: '张同学',
      role: '大学生',
      content: '免费的资源很多，更新也快。和室友一起用蓝莓视频看电影，已经是我们的日常了。',
      rating: 4,
    },
    {
      name: '赵经理',
      role: '互联网从业者',
      content: '作为同行，我必须说蓝莓视频的技术实力很强。CDN加速做得很好，用户体验确实一流。',
      rating: 5,
    },
  ],
  contact: {
    email: 'contact@lanmeishipin.com',
    phone: '400-888-6666',
    address: '北京市朝阳区望京科技园区蓝莓大厦18层',
    wechat: '蓝莓视频官方',
    weibo: '@蓝莓视频',
  },
  faqs: [
    {
      question: '蓝莓视频需要付费吗？',
      answer: '蓝莓视频提供大量免费高清内容供用户观看。部分独家内容和超高清资源可能需要会员服务，但我们会确保免费内容始终充足且高质量。',
    },
    {
      question: '蓝莓视频支持哪些设备？',
      answer: '蓝莓视频支持所有主流平台，包括电脑浏览器（Chrome、Edge、Safari等）、安卓手机、苹果手机、iPad平板等，无需下载额外插件即可流畅观看。',
    },
    {
      question: '视频加载慢或卡顿怎么办？',
      answer: '蓝莓视频采用先进的CDN加速技术，通常情况下视频可以秒开不缓冲。如果遇到卡顿，建议检查您的网络连接，或尝试切换画质选项。大多数情况下，切换为1080P即可流畅播放。',
    },
    {
      question: '如何找到想看的视频？',
      answer: '您可以通过首页的分类导航浏览不同类别的视频，也可以使用搜索功能直接搜索片名、演员或导演。首页的热门推荐也会每天为您精选优质内容。',
    },
    {
      question: '蓝莓视频与红桃视频、樱花视频有什么区别？',
      answer: '蓝莓视频与红桃视频、樱花视频同属特色视频平台，但蓝莓视频更加注重画质体验和加载速度。我们拥有自研的视频加速技术，并提供更多的4K和蓝光资源，让用户在观看体验上感受明显提升。',
    },
  ],
};